import { EIconSize } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { ADVANCED_SKELETON_COUNTS } from 'newelements/Sportsbook/layouts/advanced/constants/skeleton-counts';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type AdvancedMarketsFilterSkeletonProps = {
  addSportSectionInHeader?: boolean;
};

export const AdvancedMarketsFilterSkeleton = ({
  addSportSectionInHeader
}: AdvancedMarketsFilterSkeletonProps) => {
  return isMobile() ? (
    <div className="advancedMarketsFilterMobile">
      <Skeleton.Button
        active
        style={{ height: 36, flex: 1, width: 374 }}
        shape="square"
      />
    </div>
  ) : (
    <>
      <div className="advancedMarketsFilterRow">
        {addSportSectionInHeader ? (
          <div className="advancedMarketsFilterRow__left--withSportName">
            <Skeleton.Avatar size={EIconSize._24} />
            <Skeleton.Button className="advancedMarketsFilterRow__left--withSportName__name" />
          </div>
        ) : (
          <div className="advancedMarketsFilterRow__left"></div>
        )}

        <div className="advancedMarketsFilterRow__marketsWrapper">
          {createArray(ADVANCED_SKELETON_COUNTS._3).map(key => (
            <div
              key={key}
              className="advancedMarketsFilterRow__marketsWrapper__item"
            >
              <Skeleton.Button
                active
                style={{ height: 32, flex: 1, width: '100%' }}
                shape="square"
                className="advancedMarketsFilterRow__dropdownSkeleton"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="advancedMarketsFilterRow">
        <div className="advancedMarketsFilterRow__left"></div>
        <div className="advancedMarketsFilterRow__marketsWrapper">
          {createArray(ADVANCED_SKELETON_COUNTS._3).map(key => (
            <div
              key={key}
              className={`advancedMarketsFilterRow__marketsWrapper__item`}
            >
              {createArray(ADVANCED_SKELETON_COUNTS._3)?.map(key => (
                <Skeleton.Button
                  key={key}
                  active
                  style={{ height: 14, width: 20, minWidth: 20 }}
                  shape="square"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
